export default __webpack_public_path__ + "static/media/Fruit Toast_ proportioned_170.1da79f5e.jpg";